module.exports = __webpack_public_path__ + "img/Madeall_icon.a3dc05fd.png";